<template>
    <div class="view">
            <Model :amplitudes="amplitudes"
                   :start="start"
                   :end="end"/>

            <!--This component has a ref attribute so that its function can be called from here (see method 'updateLags')-->
            <Amplitudes ref="amplitudes"
                        :amplitudes="amplitudes"
                        @updateAmplitudes="updateAmplitudes"/>

            <IndividualForcings :amplitudes="amplitudes"
                                :start="start"
                                :end="end"/>

            <TimeInput @updateTime="updateTime"/>

            <LagsInput @updateLags="updateLags"/>
    </div>

</template>

<script>
    import {initializeModel, adjustModel} from '../model/model'
    import {getData} from "../read-data";
    import Model from '../components/Model'
    import Amplitudes from '../components/AmplitudesInput'
    import IndividualForcings from '../components/IndividualForcings'
    import LagsInput from '../components/LagsInput'
    import TimeInput from '../components/TimeInput'


    const data = getData('../data/data.csv');
    initializeModel(data);

    export default {
        components: {
            Model,
            IndividualForcings,
            TimeInput,
            LagsInput,
            Amplitudes,
        },

        data () {
            return {
                amplitudes: { enso: 0.2, volc: 0.2, sol: 0.2, anth: 0.0 },
                lags: { enso: [0, 3, 10],  volc: [3, 10], sol: [1], anth: [0] },
                start: 1979,
                end: 2018
            }
        },

        methods: {
            updateAmplitudes: function(amplitudes){
                this.amplitudes = { enso: amplitudes.enso, volc: amplitudes.volc, sol: amplitudes.sol, anth: amplitudes.anth }
            },

            updateLags: function(lags){
                this.lags = { enso: lags.enso,  volc: lags.volc, sol: lags.sol, anth: lags.anth };
                adjustModel(this.lags.enso, this.lags.volc, this.lags.sol, this.lags.anth);
                this.$refs.amplitudes.reset();
            },

            updateTime: function(start, end){
                this.start = start;
                this.end = end;
            }
        }
    }
</script>

<style scoped>
    .collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
    }

</style>
